
export class LeadStatus {

  private iconStatus: any = {
    '-1': {
      icon: 'box-archive',
      class: 'rejected'
    },
    '2': {
      icon: 'check',
      class: 'approved'
    },
    '1': {
      icon: 'hourglass-start',
      class: 'pending'
    }
  };

  private options: any = [
    { id: 1, title: 'Pendente', color: 'primary', icon: 'hourglass-start', default: true },
    { id: 2, title: 'Resolvido', color: 'success', icon: 'check', default: true },
    { id: -1, title: 'Arquivado', color: 'danger', icon: 'archive' }
  ];

  constructor() {
    return this;
  }

  getIcon(source) {
    switch (source?.toLowerCase()) {
      case 'app':
        return { icon: 'mobile', type: 'light', title: 'App Central Corretor' };
      case 'share':
        return { icon: 'share-alt', type: 'light', title: 'Link compartilhado' };
      case 'centraltree':
        return { icon: source, type: 'brand', title: 'centraltr.ee' };
      case 'instagram':
        return { icon: source, type: 'brand', title: 'Instagram' };
      case 'facebook':
        return { icon: 'facebook-f', type: 'brand', title: 'Facebook' };
      case 'site':
        return { icon: 'desktop', type: 'light', title: 'Site' };
      default:
        return { icon: 'desktop', type: 'light', title: 'Terceiros (Portais, integrações)' };
    }
  }

  getIcons() {
    return this.iconStatus;
  }
  getOptions() {
    return this.options;
  }

  getStatus(id) {
    return this.options.filter(item => item.id == id)[0];
  }
}